import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'
import { German } from 'flatpickr/dist/l10n/de.js'

export const setupDatePickers = function (parent) {
  const pickerInputs = document.querySelectorAll('input[data-date-picker]')

  if (pickerInputs.length > 0) {
    pickerInputs.forEach(function (pickerInput) {
      const lang = pickerInput.dataset.lang ?? 'en-GB'
      const locale =
        lang === 'fr-FR'
          ? French
          : lang === 'nl-NL'
            ? Dutch
            : lang === 'de-DE'
              ? German
              : {}
      locale.firstDayOfWeek = 1

      const fpConfig = {
        locale,
        showMonths: 1,
        minDate: 'today',
        disableMobile: 'true'
      }
      const fp = flatpickr(pickerInput, fpConfig)
      if (typeof (fp.calendarContainer) !== 'undefined') {
        fp.calendarContainer.classList.add('flatpickr--single-date')
      }
    })
  }
}

export const setupDatePickersWithRange = function (parent) {
  const pickerInputs = parent.querySelectorAll('input[data-date-picker-range]')

  if (pickerInputs.length > 0) {
    pickerInputs.forEach(function (pickerInput) {
      const lang = pickerInput.dataset.lang ?? 'en-GB'
      const locale =
        lang === 'fr-FR'
          ? French
          : lang === 'nl-NL'
            ? Dutch
            : lang === 'de-DE'
              ? German
              : {}
      locale.firstDayOfWeek = 1

      const fpConfig = {
        locale,
        showMonths: 2,
        minDate: 'today',
        mode: 'range',
        disableMobile: 'true'
      }
      const dp = flatpickr(pickerInput, fpConfig)
      if (typeof (dp.calendarContainer) !== 'undefined') {
        dp.calendarContainer.classList.add('flatpickr--range-date')
      }
      return dp
    })
  }
}

export const setupDatePickersBookingBar = function (element, range, initialLoad) {
  const lang = element.dataset.lang ?? 'en-GB'
  const locale =
        lang === 'fr-FR'
          ? French
          : lang === 'nl-NL'
            ? Dutch
            : lang === 'de-DE'
              ? German
              : {}
  locale.firstDayOfWeek = 1

  const fpConfig = {
    locale,
    showMonths: 2,
    inline: true,
    minDate: 'today'
  }

  if (initialLoad) {
    fpConfig.defaultDate = new Date()
  }

  if (range) {
    fpConfig.mode = 'range'
  }

  const dp = flatpickr(element, fpConfig)
  return dp
}
